export default __webpack_public_path__ + "static/media/IMG_20230716_191821_241.4d1efcf4.jpg";